// @ vendors
import { getDateWithOffset, getDayStart } from 'utilities/dateHelper/dateHelper';

const Immutable = require('immutable');
// @ commons
import { formatText } from 'core/i18n';
// @ constants
const actionTypes = require('constants/RAConstants/actionTypes');
const {
    FIRST_STEP,
    SECOND_STEP,
    RA_DATEPICKER_MAXIMUM_YEARS,
    RA_SET_GOAL_MINIMUM_INVESTMENT_AMOUNT,
} = require('constants/RAConstants');
const { GOAL_TYPE } = require('constants/RAConstants/RASetGoal');

const initialState = Immutable.fromJS({
    steps: [
        {
            valid: false,
            goalSelected: false,
            goalTypeSelected: '',
            goalSelectedFlagForRadio: true,
            goals: [
                // Hardcoded the goals content for now.
                {
                    id: 'car',
                    title: formatText('raSetGoal-goalCar'), // 'Coche Nuevo'
                    isSelected: false,
                },
                {
                    id: 'home',
                    title: formatText('raSetGoal-goalHouse'), // 'Mi Casa'
                    isSelected: false,
                },
                {
                    id: 'travel',
                    title: formatText('raSetGoal-goalTrip'), // 'Viaje'
                    isSelected: false,
                },
                {
                    id: 'education',
                    title: formatText('raSetGoal-goalEducation'), // 'Estudios',
                    isSelected: false,
                },
                {
                    id: 'others',
                    title: formatText('raSetGoal-goalOther'), // 'Otro'
                    isSelected: false,
                },
            ],
        },
        {
            valid: false,
            errorFlags: false,
            getSimulationSucceed: false,
            investmentAmount: 0,
            investmentTitle: '',
            investmentDate: getDateWithOffset(getDayStart(), { days: 1, years: 1 }),
            minDate: getDateWithOffset(getDayStart(), { days: 1, years: 1 }),
            maxDate: getDateWithOffset(getDayStart(), { years: Number(RA_DATEPICKER_MAXIMUM_YEARS) }),
        },
    ],
    visibleStep: FIRST_STEP,
    postGoalSuccess: false,
    postGoalError: false,
    isPostingGoal: false,
    isSavingGoalOnboarding: false,
    saveGoalOnboardingSuccess: false,
    saveGoalOnboardingFailure: false,
    saveGoalOnboardingError: '',
    isFetchingGoalOnboarding: false,
    isFetchedGoalOnboarding: false,
    fetchGoalOnboardingFailure: false,
    fetchGoalOnboardingError: '',
    isDeletingOnboardingGoal: false,
    deleteGoalOnboardingError: '',
    deleteGoalOnboardingFailure: false,
    deleteGoalOnboardingSuccess: false,
    type: '',
});

function setGoalValues(state, payload) {
    switch (payload.key) {
        case 'investmentAmount':
            const errorFlag = payload.value !== 0 && payload.value < RA_SET_GOAL_MINIMUM_INVESTMENT_AMOUNT;

            return state.mergeIn(['steps', SECOND_STEP], {
                errorFlags: errorFlag,
                [payload.key]: payload.value,
            });
        case 'investmentTitle':
        case 'investmentDate':
            return state.mergeIn(['steps', SECOND_STEP], {
                [payload.key]: payload.value,
            });
        default:
            return state;
    }
}

function updateGoal(state, data) {
    const selectedId = data.id;
    let goalsData = state.getIn(['steps', FIRST_STEP, 'goals']);
    const goalSelected = state.getIn(['steps', FIRST_STEP, 'goalSelected']);
    const goalSelectedFlagForRadio = state.getIn(['steps', FIRST_STEP, 'goalSelectedFlagForRadio']);

    if (goalSelected && data.isSelected) {
        // To reset imageButtons to initial state if already selected
        return initialState.mergeIn(['steps', FIRST_STEP], {
            goalSelectedFlagForRadio: !goalSelectedFlagForRadio,
        });
    }

    goalsData = goalsData.map(goal => {
        const isSelected = goal.get('id') != selectedId;

        return isSelected ? goal.update('isSelected', () => false) : goal.update('isSelected', () => true);
    });

    return initialState
        .mergeIn(['steps', FIRST_STEP], {
            goals: goalsData,
            goalTypeSelected: selectedId,
            goalSelected: selectedId !== '',
        })
        .mergeIn(['steps', SECOND_STEP], {
            investmentTitle: data.label || '',
        });
}

const RASetGoal = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RA_SET_GOAL_GET_DATA_FROM_SIMULATION:
            const immSimulation = action.payload;
            let newState = state;

            newState = updateGoal(newState, { id: immSimulation.get('type') || '' });
            newState = newState.mergeIn(['steps', SECOND_STEP], {
                investmentAmount: immSimulation.get('amount') || 0,
                investmentTitle: immSimulation.get('name') || '',
                investmentDate: immSimulation.get('endDate') ? new Date(immSimulation.get('endDate')) : null,
                errorFlags:
                    immSimulation.get('amount') < RA_SET_GOAL_MINIMUM_INVESTMENT_AMOUNT &&
                    immSimulation.get('amount') > 0,
                getSimulationSucceed: true,
            });

            return newState;
        case actionTypes.RA_SET_GOAL_RESET:
            return initialState;
        case actionTypes.RA_UPDATE_SELECTED_GOAL:
            const { goalSelected } = action.payload;

            return updateGoal(state, goalSelected);
        case actionTypes.RA_SET_GOAL_SET_VISIBLE_STEP:
            return state.merge({
                visibleStep: action.payload.step,
            });
        case actionTypes.RA_SET_GOAL_REQUEST:
            return state.merge({
                isPostGoalSuccess: true,
            });
        case actionTypes.RA_SET_GOAL_ERROR:
            return state.merge({
                isPostGoalSuccess: false,
                postGoalError: true,
            });
        case actionTypes.RA_SET_GOAL_SUCCESS:
            return state.merge({
                isPostGoalSuccess: false,
                postGoalSuccess: true,
            });
        case actionTypes.RA_SET_GOAL_SET_INVESTMENT_GOAL_VALUE:
            return setGoalValues(state, action.payload);
        case actionTypes.RA_SAVE_GOAL_ONBOARDING_REQUEST:
            return state.merge({
                isSavingGoalOnboarding: true,
            });
        case actionTypes.RA_SAVE_GOAL_ONBOARDING_SUCCESS:
            return state.merge({
                isSavingGoalOnboarding: false,
                saveGoalOnboardingSuccess: true,
                saveGoalOnboardingError: '',
            });
        case actionTypes.RA_SAVE_GOAL_ONBOARDING_FAILURE:
            return state.merge({
                isSavingGoalOnboarding: false,
                saveGoalOnboardingFailure: true,
                saveGoalOnboardingError: action.payload,
            });
        case actionTypes.RA_GET_GOAL_ONBOARDING_REQUEST:
            return state.merge({
                isFetchingGoalOnboarding: true,
            });
        case actionTypes.RA_GET_GOAL_ONBOARDING_FAILURE:
            return state.merge({
                isFetchingGoalOnboarding: false,
                fetchGoalOnboardingFailure: true,
                fetchGoalOnboardingError: action.payload,
            });
        case actionTypes.RA_DELETE_GOAL_ONBOARDING_REQUEST:
            return state.merge({
                isDeletingGoalOnboarding: true,
            });
        case actionTypes.RA_DELETE_GOAL_ONBOARDING_FAILURE:
            return state.merge({
                isDeletingGoalOnboarding: false,
                deleteGoalOnboardingError: action.payload,
                deleteGoalOnboardingFailure: true,
                deleteGoalOnboardingSuccess: false,
            });
        case actionTypes.RA_DELETE_GOAL_ONBOARDING_SUCCESS:
            return state.merge({
                isDeletingGoalOnboarding: false,
                deleteGoalOnboardingError: '',
                deleteGoalOnboardingFailure: false,
                deleteGoalOnboardingSuccess: true,
            });
        case actionTypes.RA_GET_GOAL_ONBOARDING_SUCCESS:
            let updatedState = state.merge({
                isFetchingGoalOnboarding: false,
                fetchGoalOnboardingFailure: false,
                fetchGoalOnboardingError: '',
                isFetchedGoalOnboarding: true,
            });
            updatedState = updatedState.mergeIn(['steps', FIRST_STEP], {
                goalTypeSelected: action.payload.objectiveType,
                goalSelected: !!action.payload.objectiveType,
                valid: !!action.payload.objectiveType,
            });
            updatedState = updatedState.mergeIn(['steps', SECOND_STEP], {
                investmentAmount: action.payload.objectiveAmount,
                investmentTitle: action.payload.objective,
                investmentDate: new Date(action.payload.objectiveEndDate),
                valid: true,
            });
            updatedState = updatedState.mergeIn(
                ['steps', FIRST_STEP, 'goals', GOAL_TYPE[action.payload.objectiveType]],
                {
                    isSelected: true,
                }
            );

            return updatedState;
        case actionTypes.RA_UPDATE_GOAL_FROM_SIMULATION:
            let stateNew = state.merge({
                isFetchingGoalOnboarding: false,
                fetchGoalOnboardingFailure: false,
                fetchGoalOnboardingError: '',
                isFetchedGoalOnboarding: true,
            });
            stateNew = stateNew.mergeIn(['steps', FIRST_STEP], {
                goalTypeSelected: action.payload.objectiveType,
                goalSelected: true,
                valid: true,
            });
            stateNew = stateNew.mergeIn(['steps', SECOND_STEP], {
                investmentAmount: action.payload.objectiveAmount,
                investmentTitle: action.payload.objective,
                investmentDate: new Date(action.payload.objectiveEndDate),
                valid: true,
            });
            stateNew = stateNew.mergeIn(['steps', FIRST_STEP, 'goals', GOAL_TYPE['car']], {
                isSelected: true,
            });

            return stateNew;
        default:
            return state;
    }
};

module.exports = RASetGoal;
